export default __webpack_public_path__ + "static/supportSystemListingImage4-78a1f2884c4190264dfeee12aebe84b0.webp";